<div class="rp-wrap">
  <div *ngIf="availableRoles.length === 0" class="rp-empty">Loading roles...</div>

  <div *ngFor="let grp of grouped" class="rp-group">
    <div class="rp-group-label">{{ grp.group }}</div>
    <div class="rp-chips">
      <button
        *ngFor="let role of grp.roles"
        class="rp-chip"
        [class.rp-chip--active]="isActive(role)"
        [class.rp-chip--busy]="isToggling(role)"
        [disabled]="readonly || isToggling(role)"
        (click)="toggle(role)"
        [title]="role">
        <span class="rp-chip-dot"></span>
        {{ labelFor(role) }}
      </button>
    </div>
  </div>
</div>
